import type { ReactNode } from "react";

import { AssetsService } from "app/services/AssetsService";

import { StyledNoDataContent, StyledNoDataImage, StyledNoDataSubtitle, StyledNoDataWrapper } from "./styles";

export const NoDataBanner = ({ text, height, children }: { text: string; height?: string; children?: ReactNode }) => {
    return (
        <StyledNoDataWrapper height={height}>
            <StyledNoDataImage src={AssetsService.assetUrl("/images/common/lighthouse.svg")} />
            <StyledNoDataContent>
                <StyledNoDataSubtitle withChildren={!!children}>{text}</StyledNoDataSubtitle>
                {children}
            </StyledNoDataContent>
        </StyledNoDataWrapper>
    );
};
